// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","849":"component---src-pages-pages-resource-center-js"}[chunkId] + "-" + {"532":"be1689844b28c4b67e35","678":"ab5d37ca4891567c0d8e","849":"f23a140035863a52ed52"}[chunkId] + ".js";
};